import { logger } from '../logger';
export const readyToReadActivity = {
    activityName: 'readyToRead',
    message: 'Starting the measurement when the data store is retrieved without trailing ops applied',
};
export const readyToWriteActivity = {
    activityName: 'readyToWrite',
    message: 'Starting the measurement when the data store is caught up with trailing ops',
};
/**
 * Utility method to start readyToRead, readyToWrite activities
 *
 * @param methodName Method name in which activities are started.
 * @returns Activity objects
 */
export function startDataStoreCustomActivities(methodName, activityEventType) {
    return {
        readyToRead: logger.startActivity(readyToReadActivity.activityName, activityEventType, readyToReadActivity.message, methodName),
        readyToWrite: logger.startActivity(readyToWriteActivity.activityName, activityEventType, readyToWriteActivity.message, methodName),
    };
}
//# sourceMappingURL=dataStoreCustomEventHelper.js.map